import { Outlet } from "react-router-dom";

export default function AdminOutlet() {
  return <Outlet />;
}
